import { Category } from '../constants';
import { Protocol } from './index';

const prediction: Protocol[] = [
    {
        name: 'BonderMarket',
        url: 'https://bonder.market',
        logoPath: '/logos/bm-logo-dark.jpg',
        category: Category.Prediction,
        twitterUrl: 'https://x.com/bonderdotmarket',
      }
];

export { prediction };
